module.exports = __webpack_public_path__ + "static/media/chevron_right_white.99f39297.svg";